/**
 * @param error - Axios error object from API call
 * @returns User-friendly error message string
 */
export const extractErrorMessage = (error: any): string => {
  const response = error?.response?.data;

  if (response?.errorMsg) {
    if (Array.isArray(response.errorMsg)) {
      const items = response.errorMsg;
      if (items.length === 0) {
        return "Validation error occurred";
      }
      const first = items[0];
      if (typeof first === "string") {
        const message = items
          .filter((x: unknown): x is string => typeof x === "string")
          .map((x: string) => x.trim())
          .filter(Boolean)
          .join(", ");
        if (message) return message;
      }
      if (
        first &&
        typeof first === "object" &&
        first !== null &&
        "title" in first
      ) {
        const message = items
          .map((e: { title?: string }) => e?.title)
          .map((t: string | undefined) => t?.trim())
          .filter(Boolean)
          .join(", ");
        if (message) return message;
      }
      const fallback = String(first);
      if (fallback && fallback !== "[object Object]") return fallback;
      return "Validation error occurred";
    }
    if (typeof response.errorMsg === "string") {
      return response.errorMsg;
    }
  }
  if (response?.message) {
    return response.message;
  }
  if (typeof error?.message === "string") {
    return error.message;
  }

  return "An unexpected error occurred. Please try again.";
};
